"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
var _Grants_1 = require("./_Grants");
exports.GetObjectAclOutput = {
    type: "structure",
    required: [],
    members: {
        Owner: {
            shape: _Owner_1._Owner
        },
        Grants: {
            shape: _Grants_1._Grants,
            locationName: "AccessControlList"
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=GetObjectAclOutput.js.map